import ParcelexApi from '../../services/parcelex';

export default {
  getPaymentLink({ paymentLinkId }) {
    return ParcelexApi.get(`paymentLink/${paymentLinkId}`);
  },
  getPaymentLinkCheckout({ paymentLinkId }) {
    return ParcelexApi.get(`paymentLink/${paymentLinkId}/checkout`);
  },
  acceptPaymentLinkTerms({ paymentLinkId }) {
    return ParcelexApi.post(`paymentLink/${paymentLinkId}/acceptTerms`, {});
  },
  applyForPaymentLink({ paymentLinkId, userInfo, device }) {
    const {
      cpf,
      phone,
      email,
      zipCode,
    } = userInfo;

    return ParcelexApi.post(`paymentLink/${paymentLinkId}/apply`, {
      cpf,
      phone,
      email,
      zipCode,
      device,
    });
  },
  applyComplementForPaymentLink({
    paymentLinkId,
    addressStreet,
    addressNumber,
    addressComplement,
  }) {
    return ParcelexApi.post(`paymentLink/${paymentLinkId}/apply/complement`, {
      addressStreet,
      addressNumber,
      addressComplement,
    });
  },
  getOptions({ paymentLinkId }) {
    return ParcelexApi.get(`paymentLink/${paymentLinkId}/options`);
  },
  authorize({ apiKey, optionId, orderId }) {
    return ParcelexApi.post('/public/authorize', {
      apiKey,
      optionId,
      orderId,
    });
  },
};
